import Icon from '../components/Icon.vue'

Icon.register({
  laugh: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM328 160C345.7 160 360 174.3 360 192S345.7 224 328 224 296 209.7 296 192 310.3 160 328 160zM168 160C185.7 160 200 174.3 200 192S185.7 224 168 224 136 209.7 136 192 150.3 160 168 160zM256 432H240C166.6 432 106 377 97.1 306 95.9 296.5 103.4 288 113 288H383C392.6 288 400.1 296.4 398.9 306 390 377 329.4 432 256 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/laugh.js
// module id = 05n1
// module chunks = 144